<template>
  <client-only>
    <div class="download-page red-gradient-bg">
      <the-header :line="true"></the-header>
      
      <div class="download-container">
        <h1 class="download-title">Download Artfield</h1>
        <p class="download-description">Join the growing community of creators. Download Artfield app now.</p>
        
        <div class="app-stores">
          <a href="https://apps.apple.com/app/artfield-discover-talents/id6739311179" target="_blank" class="app-store-button">
            <img src="/appstore.png" alt="Download on the App Store" class="store-badge" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.artfield.inc" target="_blank" class="app-store-button">
            <img src="/playstore.png" alt="Get it on Google Play" class="store-badge" />
          </a>
        </div>
        <div class="features-section">
          <h2 class="features-title">App Features</h2>
          <div class="features-grid">
            <div class="feature-item">
              <h3>Explore Portfolios</h3>
              <p>Discover creative work from talents around the world.</p>
            </div>
            <div class="feature-item">
              <h3>Connect with Creatives</h3>
              <p>Message and collaborate with the best talents in their field.</p>
            </div>
            <div class="feature-item">
              <h3>Follow Calendars</h3>
              <p>Stay updated with events and availability of your favorite talents.</p>
            </div>
            <div class="feature-item">
              <h3>Create Your Portfolio</h3>
              <p>Showcase your work to potential clients and collaborators.</p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </client-only>
</template>

<script setup lang="ts">
import TheHeader from '~/components/core/TheHeader.vue';

useHead({
  title: "Download Artfield - Join our Creative Community",
  meta: [
    {
      name: "description",
      content: "Download now and join the growing community of creators.",
    },
    {
      property: "og:title",
      content: "Download Artfield - Join our Creative Community",
    },
    {
      property: "og:description",
      content: "Download now and join the growing community of creators.",
    },
    {
      property: "og:image",
      content: "https://artfield.app/favicon.png"
    },
    {
      name: "keywords",
      content: "Artfield, download, app, iOS, Android, creative community",
    },
  ],
});

definePageMeta({
  layout: 'default'
});
</script>

<style scoped>
.download-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.download-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 20px;
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;
  max-height: 100vh;
  z-index: 0;
}

.download-title {
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
}

.download-description {
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  margin-bottom: 40px;
}

.app-stores {
  display: flex;
  gap: 20px;
  margin-bottom: 60px;
  flex-wrap: wrap;
  justify-content: center;
}

.app-store-button {
  display: block;
  transition: transform 0.2s ease;
}

.app-store-button:hover {
  transform: scale(1.05);
}

.store-badge {
  height: 60px;
}

.features-section {
  width: 100%;
  padding: 40px 0;
}

.features-title {
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 40px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  max-width: 800px;
  margin: 0 auto;
  gap: 30px;
}

.feature-item {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  color: #000;
}

.feature-item h3 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 15px;
}

.feature-item p {
  font-size: 16px;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .download-title {
    font-size: 32px;
  }
  
  .store-badge {
    height: 50px;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
}
</style> 